// Query-completion notification client. The config is admin-global (feature on/off
// + success/failure notification targets); the fire endpoint reads it server-side,
// so non-admins never see target ids/secrets — they only opt in per query tab.
import { api } from './api.js';

// { enabled } for everyone; admins also get { successTargetId, failureTargetId }.
export const getQueryNotifyConfig = () => api.get('/api/query-notify-config');

// Admin: save the feature toggle + targets.
export const setQueryNotifyConfig = (body) => api.put('/api/admin/query-notify-config', body);

// Fire after a run finishes. Best-effort: swallow transport errors (the query
// already ran; a failed notification shouldn't surface as a query error).
export const fireQueryNotify = (body) => api.post('/api/query-notify', body).catch(() => null);
